"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packageVersion = void 0;
/**
 * @internal
 */
exports.packageVersion = '24.7.2';
//# sourceMappingURL=version.js.map